var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74513 3.97857L10.7141 3.00965L11.6569 3.95246L10.6879 4.92138C11.509 5.94783 12 7.24984 12 8.6665C12 11.9802 9.31373 14.6665 6 14.6665C2.68629 14.6665 0 11.9802 0 8.6665C0 5.3528 2.68629 2.6665 6 2.6665C7.41667 2.6665 8.71867 3.15748 9.74513 3.97857ZM6 13.3332C8.57733 13.3332 10.6667 11.2438 10.6667 8.6665C10.6667 6.08918 8.57733 3.99984 6 3.99984C3.42267 3.99984 1.33333 6.08918 1.33333 8.6665C1.33333 11.2438 3.42267 13.3332 6 13.3332ZM5.33333 5.33317H6.66667V9.33317H5.33333V5.33317ZM3.33333 0.666504H8.66667V1.99984H3.33333V0.666504Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchIcon);
export default __webpack_public_path__ + "static/media/watch_icon.1c8316c563f1de476610ef7e288e4739.svg";
export { ForwardRef as ReactComponent };